"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var FormComponent_1 = require("@/pages/common/components/FormComponent");
var Validator_1 = require("@/utils/Validator");
var ForgotPasswordFormComponent = /** @class */ (function (_super) {
    __extends(ForgotPasswordFormComponent, _super);
    function ForgotPasswordFormComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onBlurHandlers = {
            email: _this.onBlurHandler('email', [Validator_1.fieldRequired('email'), Validator_1.email]),
        };
        return _this;
    }
    ForgotPasswordFormComponent.prototype.render = function () {
        var _a = this.state, form = _a.form, tForm = _a.tForm, ui = _a.ui, onFormSubmit = _a.onFormSubmit;
        var buttonClass = "o-btn o-btn--primary o-btn--long " + (ui.isLoading ? 'o-btn--loading' : '');
        var fieldClass = classnames_1.default([
            'c-form__input-subgroup',
            'c-form__field',
            {
                'c-form__field--disabled': ui.isLoading,
            },
        ]);
        return (React.createElement("form", { id: "forgot-password-form-component", className: "c-forms", onSubmit: this.onSubmitHandler() },
            this.renderErrors(),
            React.createElement("div", { className: "c-forms__row" },
                React.createElement("div", { className: "c-forms__cols" },
                    React.createElement("div", { className: "c-forms__col" },
                        React.createElement("div", { className: "c-forms__fields" },
                            React.createElement("div", { className: "c-forms__field" },
                                React.createElement("input", { id: "forgotPasswordInputEmail", type: "input", className: "c-forms__input", placeholder: tForm.email, value: form.email, disabled: ui.isLoading, onChange: this.onChangeHandler('email'), onBlur: this.onBlurHandlers.email }))))),
                this.renderError('email')),
            React.createElement("div", { className: "c-forms__row" },
                React.createElement("div", { className: "c-forms__col c-forms__col--range" },
                    React.createElement("div", { className: "o-recaptcha o-recaptcha--center g-recaptcha", "data-sitekey": tForm.recaptchaKey }))),
            React.createElement("div", { className: "c-forms__row" },
                React.createElement("div", { className: "c-forms__col c-forms__col--range" },
                    React.createElement("button", { id: "forgotPasswordSubmitButton", className: buttonClass, disabled: ui.isLoading, type: "submit" }, tForm.nameSubmit)))));
    };
    return ForgotPasswordFormComponent;
}(FormComponent_1.default));
exports.default = ForgotPasswordFormComponent;
